import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface PutGoodsCategoryRequest {
    product_idx: number[];
    product_category_idx: number;
}
export const usePutGoodsCategory = (successCallback?: () => void): UseMutationResult<null, Error, PutGoodsCategoryRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, PutGoodsCategoryRequest>({
        mutationFn: async (putData: PutGoodsCategoryRequest) => {
            const response = await axios.put(`${enum_api_uri.put_product_category}`, putData, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        onSuccess: (_, { product_idx }) => {
            queryClient.invalidateQueries({ queryKey: ["getGoodsList"] });
            product_idx.forEach(id => {
                queryClient.invalidateQueries({ queryKey: ["getGoodsInfo", id] });
            });
            successCallback?.();
        },
    });
};
